import * as Yup from 'yup';
// Define a validation schema for the signup form
const phoneRegExp = /^[6-9]\d{9}$/;  // Regex for validating Indian mobile numbers starting with 6-9 and having 10 digits

const bigBonanzaSchema = Yup.object().shape({
        contact: Yup.string()
        .required('Phone Number is required.').matches(phoneRegExp, 'Phone number is not valid'),  // Validates the mobile number format
});

export default bigBonanzaSchema;